// extracted by mini-css-extract-plugin
export var carrierIcon = "_ve-0";
export var carrierLogo = "_ve-1";
export var detailsSection = "_ve-2";